import { takeEvery, put, call, select, CallEffect, PutEffect, SelectEffect } from "redux-saga/effects";

import {
  GET_NOTARY_BID,
  GET_NOTARY_BID_LIST
} from "./actionTypes";

import {
  getNotaryBidListOk,
  getNotaryBidListErr,
  getNotaryBidOk,
  getNotaryBidErr,
} from "./actions";

import {
  getMyNotaryBids,
  getNotaryBid as getNotaryBidApi
} from "~/helpers/backendHelper";

import NotaryBid from "~/model/notaryBid";
import {
  GetMyNotaryBidsResponse,
  GetNotaryBidResponse,
} from "~/types/backend";

const getFilters = (status: number): Record<string, any> => {
  switch (status) {
    case NotaryBid.VIRTUAL_STATUS_ACTIVE:
      return { isActive: 1 };
    case NotaryBid.VIRTUAL_STATUS_ALL:
      return {};
    default:
      return {};
  }
};

/********** LIST **********/

function* onGetNotaryBidList({ payload: { params } }: any): Generator<SelectEffect | CallEffect | PutEffect<any>, void, number | GetMyNotaryBidsResponse> {
  try {
    const filterToggle: any = yield select((state: any) => state.NotaryBid.List.filterToggle);
    const response: any = yield call(getMyNotaryBids, { ...params, filters: getFilters(filterToggle) });
    yield put(getNotaryBidListOk(response));
  } catch (error) {
    yield put(getNotaryBidListErr(error as Error));
  }
}

/********** SINGLE **********/

function* onGetNotaryBid({ payload: { id } }: any): Generator<CallEffect | PutEffect<any>, void, GetNotaryBidResponse> {
  try {
    const response: GetNotaryBidResponse = yield call(getNotaryBidApi, id);
    yield put(getNotaryBidOk(response));
  } catch (error) {
    yield put(getNotaryBidErr(error as Error));
  }
}

function* notaryBidSaga() {
  yield takeEvery(GET_NOTARY_BID_LIST, onGetNotaryBidList);
  yield takeEvery(GET_NOTARY_BID, onGetNotaryBid);
}

export default notaryBidSaga;


